// <script src="{{ 'corona-custom.js' | asset_url }}" defer></script>

// a11y: the shipping progress bar app injects an iframe (#PBarNextFrame) with no
// title attribute (axe frame-title). The iframe is not theme markup, so patch it
// client-side; retry briefly because the app injects it after page load.
(function () {
  var attempts = 0;
  function titlePBarFrame() {
    var frame = document.getElementById('PBarNextFrame');
    if (frame) {
      if (!frame.hasAttribute('title')) {
        frame.setAttribute('title', 'Shipping progress');
      }
    } else if (attempts++ < 20) {
      setTimeout(titlePBarFrame, 500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', titlePBarFrame);
  } else {
    titlePBarFrame();
  }
})();

// a11y: the header mega-menu, account/locale dropdowns, and cart drawer wrap <li>
// elements in layout <span> wrappers directly inside <ul> (axe rules: list, listitem).
// The CSS is tightly coupled to the ul > span > li structure, so instead of
// restructuring the markup we give the wrappers explicit list semantics, which is
// ARIA-valid and clears both rules. Verified with axe-core 4.10.2 in the visible
// (state-change) drawer and open-menu states.
(function () {
  function fixListWrappers() {
    var sel = 'ul > span.skip, ul > span.tab-body, ul > span.three, ul > span.eight, ul > span.twelve, ul > span[class*="has_image_"], ul > span[class*="has_no_image_"]';
    document.querySelectorAll(sel).forEach(function (s) {
      if (!s.hasAttribute('role')) {
        s.setAttribute('role', 'list');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixListWrappers);
  } else {
    fixListWrappers();
  }
})();

document.addEventListener("DOMContentLoaded", function() {
  // if (window.location.href.indexOf('/wheelbarrows/') !== -1) {
  //     console.log('wheelbarrows');
  //   document.body.classList.add('wheelbarrows-page');
  //   var comingSoonText = document.querySelector('body.wheelbarrows-page .variant-inventory h4 span');
  //   comingSoonText.textContent = 'Call to Order';
  // }


  

  if (window.location.href === 'https://coronatools.com/account/login') {
    window.location.href = 'https://coronatools.com';
  }

    if (window.location.href === 'https://coronatools.com/account/login?return_url=%2Faccount') {
    window.location.href = 'https://coronatools.com';
  }

  const urlPattern = /^https:\/\/coronatools\.com\/default\/catalog-tools\/.*$/;
  if (urlPattern.test(window.location.href)) {
    window.location.href = 'https://coronatools.com/collections';
  }




  
  // null guard: payment button only exists on product templates; previously threw
  // "Cannot read properties of null (reading 'getAttribute')" on all other pages.
  const button = document.querySelector('.shopify-payment-button__button');
  if (button && button.getAttribute('aria-disabled') === 'true') {
    button.style.display = 'none';
  }
});
console.log('corona-custom js');
if (window.location.href.includes('resource-center')) {
  const links1 = document.querySelectorAll('a.bottompad-quarter');
  const links2 = document.querySelectorAll('.toppad-quarter a');
  const links3 = document.querySelectorAll('.product-loop a');


  // Iterate over the links
  for (const link of links1) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }

    for (const link of links2) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }
  for (const link of links3) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }
}

const pagination = document.querySelector('ul.pagination');

// const links = pagination.querySelectorAll('a');

// links.forEach(link => {
//   link.href = link.href.replace(/_6e7acf60/g, '');
// });

// null guard: file input only exists on templates with an upload field; previously
// threw "Cannot read properties of null (reading 'addEventListener')" elsewhere.
const fileInput = document.querySelector('input[type="file"]');

if (fileInput) {
  fileInput.addEventListener('change', function() {

    const file = this.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    if (!allowedTypes.includes(file.type)) {
      alert("Invalid file type. Please upload a JPG, PNG, or PDF file.");
      this.value = ''; // Clear the file input
      return false;

    }


  });
}

